import React, { useEffect, useState } from 'react'

import { ReactComponent as CloseIcon } from '../../../Assets/alert_close.svg'
import { ReactComponent as AlertIcon } from '../../../Assets/page_alert.svg'
import { useDeviceDetector } from '../../../Hooks/useDeviceDetector'
import Paragraph from '../../atoms/Paragraph'

type Props = {
  title: string
  alertBody: any
  expireDateTime: string
  startingDateTime: string
  version: string
}
const PopUp = ({ title, alertBody, expireDateTime, startingDateTime, version }: Props) => {
  const [isVisible, setIsVisible] = useState(false)
  const { isMobile } = useDeviceDetector()

  useEffect(() => {
    const now = new Date()
    const start = new Date(startingDateTime)
    const expiry = new Date(expireDateTime)

    const storageKey = `alertSeen_${version}`
    const alertSeen = localStorage.getItem(storageKey)

    // Cleanup: remove old version keys
    for (const key of Object.keys(localStorage)) {
      if (key.startsWith('alertSeen_') && key !== storageKey) {
        localStorage.removeItem(key)
      }
    }
    const isActive = now >= start && now <= expiry

    if (isActive && !alertSeen) {
      setIsVisible(true)
      localStorage.setItem(storageKey, 'true')
    }
  }, [startingDateTime, expireDateTime])

  if (!isVisible) return null

  const closePopup = () => {
    setIsVisible(false)
  }

  return (
    isVisible && (
      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#221535E5]">
        <div className="sm: max-h-[75vh] max-w-[calc(100vw-30px)] overflow-y-auto rounded-lg bg-white px-6 pb-[40px] pt-6 text-white sm:w-auto sm:max-w-xl">
          <div className="flex justify-between sm:justify-end">
            {isMobile && <AlertIcon />}
            <button className="self-start sm:self-auto" onClick={closePopup}>
              <CloseIcon />
            </button>
          </div>
          {!isMobile && (
            <div className="flex">
              <AlertIcon />
              <h2 className="ml-[20px] text-[32px] text-[#49247D]">{title}</h2>
            </div>
          )}
          {isMobile && <h2 className="mt-[6px] text-[32px] text-[#49247D] sm:ml-[20px] sm:mt-0">{title}</h2>}

          <div className="mt-[20px] flex flex-col sm:pl-[60px] md:gap-[16px]">
            <Paragraph content={alertBody} classes="text-black text-[18px]" />
            <div className="flex justify-start">
              <button className="rounded-lg bg-[#49247D] px-[24px] py-16 text-[18px] text-white" onClick={closePopup}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  )
}

export default PopUp
